// Boss part textures (built once at boot). The Singularity Heart draws its own
// procedural textures on first spawn.
import type Phaser from 'phaser';
import { buildTitanArt } from './art-titan';
import { buildWardenArt } from './art-warden';
import { applyPaintedBossArt } from './painted';

export function buildBossArt(scene: Phaser.Scene): void {
  for (const build of [buildWardenArt, buildTitanArt]) {
    try {
      build(scene);
    } catch (err) {
      console.error('[bosses] art builder failed', err);
    }
  }
  // AI-painted parts replace the procedural ones in place (same keys, sizes and pivots).
  try {
    applyPaintedBossArt(scene);
  } catch (err) {
    console.error('[bosses] painted art failed', err);
  }
}
